import { useRouter } from 'next/router';

import PageSection from '@components/PageSection';
import Button from '@components/uiKit/Button';

import { NOT_FOUND_PAGE_CONTENT } from './constants';
import styles from './NotFoundPage.module.scss';

interface NotFoundPageProps {
    isNotFound?: boolean;
}

const NotFoundPage = ({ isNotFound = true }: NotFoundPageProps) => {
    const router = useRouter();
    const contentKey = isNotFound ? 'notFound' : 'error';
    const { title, descriptionText, descriptionSubText, buttonAriaLabel } = NOT_FOUND_PAGE_CONTENT[contentKey];

    const handleAction = () => {
        router.push('/');
    };

    return (
        <>
            <PageSection fullHeight className={styles.notFoundPage} containerClassName={styles.notFoundPage_container}>
                <div className={styles.notFoundPage_content}>
                    <div className={styles.notFoundPage_title}>{title}</div>
                    <div className={styles.notFoundPage_description}>
                        <p>{descriptionText}</p>
                        <p>{descriptionSubText}</p>
                    </div>
                    <Button
                        variant="mainOrange"
                        size="lg"
                        sizeByBreakpoint={{ xs: 'md' }}
                        aria-label={buttonAriaLabel}
                        onClick={handleAction}
                    >
                        На главную
                    </Button>
                </div>
            </PageSection>
            {isNotFound && (
                <PageSection>
                    <div id="digi-recs" />
                    <div className="404_page.personalised" />
                </PageSection>
            )}
        </>
    );
};

export default NotFoundPage;
